import { render, staticRenderFns } from "./BoListFilters.vue?vue&type=template&id=c9f1ef16&"
import script from "./BoListFilters.vue?vue&type=script&lang=ts&"
export * from "./BoListFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports